export const ACTION_RESET = 'FETCH_INDEXPAGE_RESET';
export const ACTION_REQUEST = 'FETCH_INDEXPAGE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_INDEXPAGE_SUCCESS';
export const ACTION_ERROR = 'FETCH_INDEXPAGE_ERROR';
